import { createAsyncThunk } from '@reduxjs/toolkit'

import { SOMETHING_WHEN_WRONG } from 'constant/errorMessages'
import { callErrorMsg } from 'helpers/errorMsg'

import type {
  ApprovalLogParamsInterface,
  ApprovalSubmissionParamsInterface,
} from 'features/ApprovalEngine/@types/ApprovalListTypes'
import {
  getApprovalEngineListAPI,
  getApprovalEngineLogAPI,
  getWorkflowsApprovalAPI,
  putApprovalEngineSubmitAPI,
} from 'features/ApprovalEngine/services/ApprovalEngineList'
import {
  setIsLoading,
  setDetail,
  setIsLoadingApprovalLogs,
  setApprovalLogs,
  setApprovalLogsPagination,
  setIsLoadingWorkflow,
  setWorkflow,
} from 'features/ApprovalEngine/redux/approvalEngineDetail/slice'

const SLICE_NAME = 'approvalEngineDetail'

export const fetchApprovalEngineDetail = createAsyncThunk(
  `${SLICE_NAME}/getApprovalEngineDetail`,
  async (
    { request_number, view }: { request_number: string; view: string },
    { rejectWithValue, dispatch },
  ) => {
    dispatch(setIsLoading(true))
    try {
      const res = await getApprovalEngineListAPI({ request_number, view })
      const item = res.data.data?.[0] ?? null
      dispatch(setDetail(item))
      dispatch(setIsLoading(false))
      return true
    } catch (error) {
      callErrorMsg(error)
      dispatch(setIsLoading(false))
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchApprovalEngineApprovalLogs = createAsyncThunk(
  `${SLICE_NAME}/getApprovalEngineApprovalLogs`,
  async (params: ApprovalLogParamsInterface, { rejectWithValue, dispatch }) => {
    dispatch(setIsLoadingApprovalLogs(true))
    try {
      const res = await getApprovalEngineLogAPI(params)
      dispatch(setApprovalLogs(res.data.data ?? []))
      dispatch(setApprovalLogsPagination(res.data.pagination))
      dispatch(setIsLoadingApprovalLogs(false))
      return true
    } catch (error) {
      callErrorMsg(error)
      dispatch(setIsLoadingApprovalLogs(false))
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchApprovalWorkflow = createAsyncThunk(
  `${SLICE_NAME}/getApprovalWorkflow`,
  async (id: string | number, { rejectWithValue, dispatch }) => {
    dispatch(setIsLoadingWorkflow(true))
    try {
      const res = await getWorkflowsApprovalAPI(id)
      dispatch(setWorkflow(res.data.data ?? null))
      dispatch(setIsLoadingWorkflow(false))
      return true
    } catch (error) {
      callErrorMsg(error)
      dispatch(setIsLoadingWorkflow(false))
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const putApproveApproval = createAsyncThunk(
  `${SLICE_NAME}/putApproveApproval`,
  async (params: ApprovalSubmissionParamsInterface, { rejectWithValue }) => {
    try {
      const res = await putApprovalEngineSubmitAPI(params)
      return res.data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)
